/**
 * 사전학습 허브 — 책 메타(title/author)로 외부 검색 링크를 생성하는 순수 빌더.
 * 외부 API·LLM 호출 0(정적 검색 URL). AI 배경요약은 유료라 별도(최종 단계).
 */
export interface PrelearnLink {
  key: string;
  label: string;
  url: string;
  group: 'books' | 'media';
}

export function prelearnLinks(title: string, author?: string | null): PrelearnLink[] {
  const t = encodeURIComponent(title || '');
  const ta = encodeURIComponent([title, author].filter(Boolean).join(' '));
  return [
    { key: 'kyobo', label: '교보문고', group: 'books',
      url: `https://search.kyobobook.co.kr/search?keyword=${t}` },
    { key: 'yes24', label: 'YES24', group: 'books',
      url: `https://www.yes24.com/product/search?query=${t}` },
    { key: 'aladin', label: '알라딘', group: 'books',
      url: `https://www.aladin.co.kr/search/wsearchresult.aspx?SearchWord=${t}` },
    { key: 'youtube', label: 'YouTube', group: 'media',
      url: `https://www.youtube.com/results?search_query=${encodeURIComponent(`${title} 해설`)}` },
    { key: 'ted', label: 'TED', group: 'media',
      url: `https://www.ted.com/search?q=${ta}` },
    { key: 'wikipedia', label: 'Wikipedia', group: 'media',
      url: `https://ko.wikipedia.org/w/index.php?search=${ta}` },
  ];
}
